import classNames from 'classnames';
import React, { memo } from 'react';

import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { useTHelper } from 'src/utils/i18n';
import { UiButton } from 'src/components/UI/Button';
import { shareLink, ShareLinkType } from 'src/utils/shareLink';
import { ShareIcons } from 'src/components/common/ShareIcons';

type Props = {
  model: CheckoutConfirmationResponseType['SharingSubsection'];
};

export const CheckoutConfirmationSharing = memo<Props>(({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.sharing');

  const links: { type: ShareLinkType; className: string }[] = [
    { type: 'Facebook', className: 'fb-bg' },
    { type: 'Twitter', className: 'tw-bg' },
    { type: 'Link', className: 'link-bg' },
  ];

  return (
    <div className="social-wrapper">
      <div className="banner-share">
        <div className="social-icons-header HeaderTextColor">{tHelper('title')}</div>
        {!model?.CampaignSharingImprovements26794Enabled ? (
          <div className="socials-icons-container">
            {links.map((item) => (
              <UiButton
                key={item.type}
                className={classNames(`btn-floating display-inline-flex`, item.className)}
                onClick={() => {
                  shareLink(item.type, model.SharingLink);
                }}
                tag="a"
                effects
              >
                <i className={`fa fa-${item.type.toLowerCase()} fa-fixed-align`} />
              </UiButton>
            ))}
          </div>
        ) : (
          <ShareIcons
            sharinkLink={model.SharingLink}
            MobileSharingTitle={model.MobileSharingTitle}
            MobileSharingText={model.MobileSharingText}
            EmailSubject={model.EmailSubject}
            EmailBody={model.EmailBody}
          />
        )}
      </div>
    </div>
  );
});
